import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AuthProvider } from './lib/auth-context.js';
import { Header } from './components/header.js';
import { HomePage } from './pages/home.js';
import { TalentPage } from './pages/talent.js';
import { TulpaPage } from './pages/tulpa.js';
import { PublishPage } from './pages/publish.js';
import { PublishDetailPage } from './pages/publish-detail.js';
import { PublishTulpaDetailPage } from './pages/publish-tulpa-detail.js';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen flex flex-col">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/t/:slug" element={<TalentPage />} />
            <Route path="/u/:slug" element={<TulpaPage />} />
            <Route path="/publish" element={<PublishPage />} />
            <Route path="/publish/:slug" element={<PublishDetailPage />} />
            <Route path="/publish/tulpa/:slug" element={<PublishTulpaDetailPage />} />
            <Route
              path="*"
              element={<div className="container py-12 text-muted-foreground">Not found.</div>}
            />
          </Routes>
          <footer className="border-t mt-auto">
            <div className="container py-4 text-xs text-muted-foreground">
              mp.langgenius.app — arx-marketplace-cf
            </div>
          </footer>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}
